import React from "react";
import {
	Box,
	ButtonStyled,
	HeadingStyled,
	LazyImage,
	// LazyImage,
	TextStyled,
} from "../../../components/styled/Elements";
import { ForgetPassImg, VerifyImg } from "../../../components/styled/AllImages";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const EmailSentModal = (props) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	return (
		<Modal
			{...props}
			size="md"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Body>
				<Box className="d-flex flex-column align-items-center py-3 px-2">
					<Box>
						<LazyImage src={VerifyImg} />
					</Box>
					<Box>
						<HeadingStyled size="24px" className="mb-2 mt-3">
							{t("VerifyYourAccount")}
						</HeadingStyled>
					</Box>
					<Box>
						<TextStyled
							size="16px"
							color="var(--lightGrey)"
							className="text-center px-3 mb-2"
						>
							{t("Pleasecheckemail")}
						</TextStyled>
					</Box>
					<ButtonStyled
						onClick={() => navigate("/login")}
						className="w-100"
						clName="w-100"
						label={t("CheckEmail")}
					/>
				</Box>
			</Modal.Body>
		</Modal>
	);
};

export default EmailSentModal;
